<template>

    <v-page fixed>

        <v-page-header title="Account" icon="fas fa-id-badge" />

        <div class="page-body-container">
            <v-page-body-sidebar>
                <router-link class="nav-link" :to="{ name: 'account-settings' }" :class="{ active: $route.name === 'account-settings' }">Account</router-link>
                <router-link class="nav-link" :to="{ name: 'company-settings' }" :class="{ active: $route.name === 'company-settings' }">Company</router-link>
                <router-link v-if="['owner', 'admin'].includes(user.member.role.slug)" class="nav-link" :to="{ name: 'members' }" :class="{ active: $route.name.startsWith('members') }">Members</router-link>
                <router-link v-if="['owner'].includes(user.member.role.slug)" class="nav-link" :to="{ name: 'billing' }" :class="{ active: $route.name.startsWith('billing') }">Billing</router-link>
            </v-page-body-sidebar>
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>

    </v-page>

</template>

<script>

export default {

    computed: {

        user() {
            return this.$store.getters.user;
        },

    },

}

</script>